<!--扩展标签模块-->
<template>
  <div class="xz_module_publish">
    <div class="draft-job">
      <h5>扩展标签</h5>
    </div>
    <div class="infor_field flexStart">
      <label class="field_name">专业证书: </label>
      <MultipleSelect :custom="true" customlabel="新增标签" :options="knowBtn" :selected="selectedKnowBtn" @change="(arr) => settingLabel(arr, 'selectedKnowBtn')"></MultipleSelect>
    </div>
    <div class="infor_field flexStart">
      <label class="field_name">工具工艺: </label>
      <MultipleSelect :custom="true" customlabel="新增标签" :options="skillBtn" :selected="selectedSkillBtn" @change="(arr) => settingLabel(arr, 'selectedSkillBtn')"></MultipleSelect>
      
    </div>
    <div class="infor_field flexStart">
      <label class="field_name">软件系统: </label>
      <MultipleSelect :custom="true" customlabel="新增标签" :options="toolBtn" :selected="selectedToolBtn" @change="(arr) => settingLabel(arr, selectedToolBtn)"></MultipleSelect>
      
    </div>
    <!-- <div class="infor_field flexStart">
      <label class="field_name">简历身份: </label>
      <MultipleSelect2 :custom="true" customlabel="新增标签" :options="otherBtn" :selected="selectedOtherBtn" @change="(arr) => settingLabel(arr, 'selectedOtherBtn')"></MultipleSelect2>
    </div> -->
  </div>
</template>
<script>
import MultipleSelect from "../widgets/multipleSelect";
// import MultipleSelect2 from "../widgets/multipleSelect2";
export default {
  components: {
    MultipleSelect
  },
  data(){
    return {
      identity: "",
      // 专业证书
      otherBtn: this.$store.state.PUBLISH.otherBtn,
      // 工具工艺
      skillBtn: this.$store.state.PUBLISH.skillBtn,
      // 软件系统
      toolBtn: this.$store.state.PUBLISH.toolBtn,
      // 其他要求
      knowBtn: this.$store.state.PUBLISH.knowBtn,
      // 选择的专业证书
      selectedOtherBtn: [],
      // 选择的工具工艺
      selectedSkillBtn: [],
      // 选择的软件系统
      selectedToolBtn: [],
      // 选择的其他要求
      selectedKnowBtn: []
    }
  },
  mounted(){
  },
  watch: {
    "$store.state.PUBLISH.jobInfo": {
      handler: function(){
        if(this.$store.state.PUBLISH.jobInfo){
          const info = this.$store.state.PUBLISH.jobInfo;
          this.selectedOtherBtn = info.entJobOtherTag;
          this.selectedSkillBtn = info.entJobSkillTag;
          this.selectedToolBtn = info.entJobToolTag;
          this.selectedKnowBtn = info.entJobKnowTag;
        }
      }
    },
  },
  methods: {
    settingLabel(arr, type){
      this[type] = arr;
    },

    // 返回数据
    returnVal(){
      return {
        selectedOtherBtn: this.selectedOtherBtn,
        selectedSkillBtn: this.selectedSkillBtn,
        selectedToolBtn: this.selectedToolBtn,
        selectedKnowBtn: this.selectedKnowBtn,
        status: true
      }
    },
  }
}
</script>
<style>
@import url("../../assets/css/module_publish.css");
</style>